
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      discovery: "Discovery",
      matching: "Matching", 
      messages: "Messages",
      buzzz: "Buzzz",
      
      // Settings
      settings: "Settings",
      settings_subtitle: "Manage your Alpha_v8 preferences",
      appearance: "Appearance",
      appearance_description: "Customize the look and feel of the app",
      language: "Language Preferences",
      notifications: "Notifications",
      privacy: "Privacy",
      discovery_settings: "Discovery",
      safety: "Safety",
      signOut: "Sign Out",
      
      // Language Section
      language_preferences: "Language Preferences",
      language_description: "Choose your preferred language for the app interface",
      interface_language: "Interface Language",
      apply_language: "Apply Language",
      language_applied: "Language applied successfully!",
      
      // Profile
      profile: "Profile",
      edit_profile: "Edit Profile",
      about: "About",
      interests: "Interests",
      photos: "Photos",
      basic_info: "Basic Information",
      looking_for: "Looking for",
      relationship: "Relationship",
      body_type: "Body type",
      height: "Height",
      ethnicity: "Ethnicity",
      member_since: "Member since",
      profile_views: "Profile views",
      favorites: "Favorites",
      active_now: "Active now",
      online: "Online",
      offline: "Offline",
      
      // Actions
      message: "Message",
      send_message: "Send Message",
      favorite: "Favorite",
      block: "Block",
      report: "Report",
      
      // Common
      save: "Save",
      cancel: "Cancel",
      apply: "Apply",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      close: "Close",
      back: "Back",
      next: "Next",
      previous: "Previous",
      
      // Buzzz Page
      buzzz_received: "Buzzz",
      visitors: "Visitors", 
      visited: "Visited",
      no_buzzz: "No buzzz received",
      no_visitors: "No visitors yet",
      no_visited: "No profiles visited",
      
      // Messages
      no_messages: "No messages yet",
      start_conversation: "Start a conversation",
      type_message: "Type a message...",
      
      // Discovery
      no_profiles: "No profiles found",
      discover_people: "Discover People",
      filters: "Filters",
      
      // Auth
      sign_in: "Sign In",
      sign_up: "Sign Up",
      email: "Email",
      password: "Password",
      username: "Username",
      forgot_password: "Forgot Password?",
      
      // Errors
      loading_error: "Failed to load",
      network_error: "Network error",
      try_again: "Try again",
    }
  },
  de: {
    translation: {
      // Navigation
      discovery: "Entdeckung",
      matching: "Übereinstimmungen", 
      messages: "Nachrichten",
      buzzz: "Buzzz",
      
      // Settings
      settings: "Einstellungen",
      settings_subtitle: "Verwalten Sie Ihre Alpha_v8-Einstellungen",
      appearance: "Erscheinungsbild",
      appearance_description: "Passen Sie das Aussehen und die Haptik der App an",
      language: "Spracheinstellungen",
      notifications: "Benachrichtigungen",
      privacy: "Datenschutz",
      discovery_settings: "Entdeckung",
      safety: "Sicherheit",
      signOut: "Abmelden",
      
      // Language Section
      language_preferences: "Spracheinstellungen",
      language_description: "Wählen Sie Ihre bevorzugte Sprache für die App-Oberfläche",
      interface_language: "Oberflächensprache",
      apply_language: "Sprache anwenden",
      language_applied: "Sprache erfolgreich angewendet!",
      
      // Profile
      profile: "Profil",
      edit_profile: "Profil bearbeiten",
      about: "Über mich",
      interests: "Interessen",
      photos: "Fotos",
      basic_info: "Grundinformationen",
      looking_for: "Suche nach",
      relationship: "Beziehung",
      body_type: "Körpertyp",
      height: "Größe",
      ethnicity: "Ethnie",
      member_since: "Mitglied seit",
      profile_views: "Profilaufrufe",
      favorites: "Favoriten",
      active_now: "Jetzt aktiv",
      online: "Online",
      offline: "Offline",
      
      // Actions
      message: "Nachricht",
      send_message: "Nachricht senden",
      favorite: "Favorit",
      block: "Blockieren",
      report: "Melden",
      
      // Common
      save: "Speichern",
      cancel: "Abbrechen",
      apply: "Anwenden",
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      close: "Schließen",
      back: "Zurück",
      next: "Weiter",
      previous: "Vorherige",
      
      // Buzzz Page
      buzzz_received: "Buzzz",
      visitors: "Besucher", 
      visited: "Besucht",
      no_buzzz: "Kein Buzzz erhalten",
      no_visitors: "Noch keine Besucher",
      no_visited: "Keine Profile besucht",
      
      // Messages
      no_messages: "Noch keine Nachrichten",
      start_conversation: "Unterhaltung beginnen",
      type_message: "Nachricht eingeben...",
      
      // Discovery
      no_profiles: "Keine Profile gefunden",
      discover_people: "Menschen entdecken",
      filters: "Filter",
      
      // Auth
      sign_in: "Anmelden",
      sign_up: "Registrieren",
      email: "E-Mail",
      password: "Passwort",
      username: "Benutzername",
      forgot_password: "Passwort vergessen?",
      
      // Errors
      loading_error: "Laden fehlgeschlagen",
      network_error: "Netzwerkfehler",
      try_again: "Erneut versuchen",
    }
  },
  es: {
    translation: {
      // Navigation
      discovery: "Descubrimiento",
      matching: "Coincidencias", 
      messages: "Mensajes",
      buzzz: "Buzzz",
      
      // Settings
      settings: "Configuración",
      settings_subtitle: "Administra tus preferencias de Alpha_v8",
      appearance: "Apariencia",
      appearance_description: "Personaliza la apariencia de la aplicación",
      language: "Preferencias de idioma",
      notifications: "Notificaciones",
      privacy: "Privacidad",
      discovery_settings: "Descubrimiento",
      safety: "Seguridad",
      signOut: "Cerrar sesión",
      
      // Language Section
      language_preferences: "Preferencias de idioma",
      language_description: "Elige tu idioma preferido para la interfaz de la aplicación",
      interface_language: "Idioma de la interfaz",
      apply_language: "Aplicar idioma",
      language_applied: "¡Idioma aplicado con éxito!",
      
      // Profile
      profile: "Perfil",
      edit_profile: "Editar perfil",
      about: "Acerca de",
      interests: "Intereses",
      photos: "Fotos",
      basic_info: "Información básica",
      looking_for: "Buscando",
      relationship: "Relación",
      body_type: "Tipo de cuerpo",
      height: "Altura",
      ethnicity: "Etnia",
      member_since: "Miembro desde",
      profile_views: "Vistas del perfil",
      favorites: "Favoritos",
      active_now: "Activo ahora",
      online: "En línea",
      offline: "Desconectado",
      
      // Actions
      message: "Mensaje",
      send_message: "Enviar mensaje",
      favorite: "Favorito",
      block: "Bloquear",
      report: "Reportar",
      
      // Common
      save: "Guardar",
      cancel: "Cancelar",
      apply: "Aplicar",
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      close: "Cerrar",
      back: "Atrás",
      next: "Siguiente",
      previous: "Anterior",
      
      // Buzzz Page
      buzzz_received: "Buzzz",
      visitors: "Visitantes", 
      visited: "Visitado",
      no_buzzz: "No se recibió buzzz",
      no_visitors: "Aún no hay visitantes",
      no_visited: "No se visitaron perfiles",
      
      // Messages
      no_messages: "Aún no hay mensajes",
      start_conversation: "Iniciar conversación",
      type_message: "Escribe un mensaje...",
      
      // Discovery
      no_profiles: "No se encontraron perfiles",
      discover_people: "Descubrir personas",
      filters: "Filtros",
      
      // Auth
      sign_in: "Iniciar sesión",
      sign_up: "Registrarse",
      email: "Correo electrónico",
      password: "Contraseña",
      username: "Nombre de usuario",
      forgot_password: "¿Olvidaste tu contraseña?",
      
      // Errors
      loading_error: "Error al cargar",
      network_error: "Error de red",
      try_again: "Intentar de nuevo",
    }
  },
  fr: {
    translation: {
      // Navigation
      discovery: "Découverte",
      matching: "Correspondances", 
      messages: "Messages",
      buzzz: "Buzzz",
      
      // Settings
      settings: "Paramètres",
      settings_subtitle: "Gérez vos préférences Alpha_v8",
      appearance: "Apparence",
      appearance_description: "Personnalisez l'apparence de l'application",
      language: "Préférences linguistiques",
      notifications: "Notifications",
      privacy: "Confidentialité",
      discovery_settings: "Découverte",
      safety: "Sécurité",
      signOut: "Se déconnecter",
      
      // Language Section
      language_preferences: "Préférences linguistiques",
      language_description: "Choisissez votre langue préférée pour l'interface de l'application",
      interface_language: "Langue de l'interface",
      apply_language: "Appliquer la langue",
      language_applied: "Langue appliquée avec succès !",
      
      // Profile
      profile: "Profil",
      edit_profile: "Modifier le profil",
      about: "À propos",
      interests: "Intérêts",
      photos: "Photos",
      basic_info: "Informations de base",
      looking_for: "Recherche",
      relationship: "Relation",
      body_type: "Type de corps",
      height: "Taille",
      ethnicity: "Origine ethnique",
      member_since: "Membre depuis",
      profile_views: "Vues du profil",
      favorites: "Favoris",
      active_now: "Actif maintenant",
      online: "En ligne",
      offline: "Hors ligne",
      
      // Actions
      message: "Message",
      send_message: "Envoyer un message",
      favorite: "Favori",
      block: "Bloquer",
      report: "Signaler",
      
      // Common
      save: "Enregistrer",
      cancel: "Annuler",
      apply: "Appliquer",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      close: "Fermer",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      
      // Buzzz Page
      buzzz_received: "Buzzz",
      visitors: "Visiteurs", 
      visited: "Visité",
      no_buzzz: "Aucun buzzz reçu",
      no_visitors: "Pas encore de visiteurs",
      no_visited: "Aucun profil visité",
      
      // Messages
      no_messages: "Pas encore de messages",
      start_conversation: "Commencer une conversation",
      type_message: "Tapez un message...",
      
      // Discovery
      no_profiles: "Aucun profil trouvé",
      discover_people: "Découvrir des personnes",
      filters: "Filtres",
      
      // Auth
      sign_in: "Se connecter",
      sign_up: "S'inscrire",
      email: "E-mail",
      password: "Mot de passe",
      username: "Nom d'utilisateur",
      forgot_password: "Mot de passe oublié ?",
      
      // Errors
      loading_error: "Échec du chargement",
      network_error: "Erreur réseau",
      try_again: "Réessayer",
    }
  },
  he: {
    translation: {
      // Navigation
      discovery: "גילוי",
      matching: "התאמות",
      messages: "הודעות", 
      buzzz: "באזז",
      
      // Settings
      settings: "הגדרות",
      settings_subtitle: "נהל את העדפות Alpha_v8 שלך",
      appearance: "מראה",
      appearance_description: "התאם את המראה והתחושה של האפליקציה",
      language: "העדפות שפה",
      notifications: "התראות",
      privacy: "פרטיות",
      discovery_settings: "גילוי",
      safety: "בטיחות",
      signOut: "התנתק",
      
      // Language Section
      language_preferences: "העדפות שפה",
      language_description: "בחר את השפה המועדפת עליך עבור ממשק האפליקציה",
      interface_language: "שפת הממשק",
      apply_language: "החל שפה",
      language_applied: "השפה הוחלה בהצלחה!",
      
      // Profile
      profile: "פרופיל",
      edit_profile: "ערוך פרופיל",
      about: "אודות",
      interests: "תחומי עניין",
      photos: "תמונות",
      basic_info: "מידע בסיסי",
      looking_for: "מחפש",
      relationship: "מערכת יחסים",
      body_type: "מבנה גוף",
      height: "גובה",
      ethnicity: "מוצא",
      member_since: "חבר מאז",
      profile_views: "צפיות בפרופיל",
      favorites: "מועדפים",
      active_now: "פעיל כעת",
      online: "מחובר",
      offline: "לא מחובר",
      
      // Actions
      message: "הודעה",
      send_message: "שלח הודעה",
      favorite: "מועדף",
      block: "חסום",
      report: "דווח",
      
      // Common
      save: "שמור",
      cancel: "בטל",
      apply: "החל",
      loading: "טוען...",
      error: "שגיאה",
      success: "הצלחה",
      close: "סגור",
      back: "חזור",
      next: "הבא",
      previous: "קודם",
      
      // Buzzz Page
      buzzz_received: "באזז",
      visitors: "מבקרים",
      visited: "ביקרתי",
      no_buzzz: "לא התקבל באזז",
      no_visitors: "עדיין אין מבקרים",
      no_visited: "לא ביקרת בפרופילים",
      
      // Messages
      no_messages: "אין הודעות עדיין",
      start_conversation: "התחל שיחה",
      type_message: "הקלד הודעה...",
      
      // Discovery
      no_profiles: "לא נמצאו פרופילים",
      discover_people: "גלה אנשים",
      filters: "מסננים",
      
      // Auth
      sign_in: "התחבר",
      sign_up: "הירשם",
      email: "אימייל",
      password: "סיסמה",
      username: "שם משתמש",
      forgot_password: "שכחת סיסמה?",
      
      // Errors
      loading_error: "נכשל בטעינה",
      network_error: "שגיאת רשת",
      try_again: "נסה שוב",
    }
  },
  it: {
    translation: {
      // Navigation
      discovery: "Scoperta",
      matching: "Corrispondenze", 
      messages: "Messaggi",
      buzzz: "Buzzz",
      
      // Settings
      settings: "Impostazioni",
      settings_subtitle: "Gestisci le tue preferenze Alpha_v8",
      appearance: "Aspetto",
      appearance_description: "Personalizza l'aspetto dell'app",
      language: "Preferenze linguistiche",
      notifications: "Notifiche",
      privacy: "Privacy",
      discovery_settings: "Scoperta",
      safety: "Sicurezza",
      signOut: "Disconnetti",
      
      // Language Section
      language_preferences: "Preferenze linguistiche",
      language_description: "Scegli la tua lingua preferita per l'interfaccia dell'app",
      interface_language: "Lingua dell'interfaccia",
      apply_language: "Applica lingua",
      language_applied: "Lingua applicata con successo!",
      
      // Profile
      profile: "Profilo",
      edit_profile: "Modifica profilo",
      about: "Informazioni",
      interests: "Interessi",
      photos: "Foto",
      basic_info: "Informazioni di base",
      looking_for: "Cerco",
      relationship: "Relazione",
      body_type: "Tipo di corpo",
      height: "Altezza",
      ethnicity: "Etnia",
      member_since: "Membro dal",
      profile_views: "Visualizzazioni profilo",
      favorites: "Preferiti",
      active_now: "Attivo ora",
      online: "Online",
      offline: "Offline",
      
      // Actions
      message: "Messaggio",
      send_message: "Invia messaggio",
      favorite: "Preferito",
      block: "Blocca",
      report: "Segnala",
      
      // Common
      save: "Salva",
      cancel: "Annulla",
      apply: "Applica",
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      close: "Chiudi",
      back: "Indietro",
      next: "Avanti",
      previous: "Precedente",
      
      // Buzzz Page
      buzzz_received: "Buzzz",
      visitors: "Visitatori", 
      visited: "Visitato",
      no_buzzz: "Nessun buzzz ricevuto",
      no_visitors: "Nessun visitatore ancora",
      no_visited: "Nessun profilo visitato",
      
      // Messages
      no_messages: "Nessun messaggio ancora",
      start_conversation: "Inizia una conversazione",
      type_message: "Scrivi un messaggio...",
      
      // Discovery
      no_profiles: "Nessun profilo trovato",
      discover_people: "Scopri persone",
      filters: "Filtri",
      
      // Auth
      sign_in: "Accedi",
      sign_up: "Registrati",
      email: "Email",
      password: "Password",
      username: "Nome utente",
      forgot_password: "Password dimenticata?",
      
      // Errors
      loading_error: "Caricamento fallito",
      network_error: "Errore di rete",
      try_again: "Riprova",
    }
  },
  // Adding basic translations for other languages to prevent errors
  pl: {
    translation: {
      discovery: "Odkrywanie",
      matching: "Dopasowania",
      messages: "Wiadomości",
      buzzz: "Buzzz",
      settings: "Ustawienia",
      settings_subtitle: "Zarządzaj swoimi preferencjami Alpha_v8",
      appearance: "Wygląd",
      appearance_description: "Dostosuj wygląd aplikacji",
      language: "Preferencje językowe",
      notifications: "Powiadomienia",
      privacy: "Prywatność",
      discovery_settings: "Odkrywanie",
      safety: "Bezpieczeństwo",
      signOut: "Wyloguj się",
      language_preferences: "Preferencje językowe",
      language_description: "Wybierz preferowany język interfejsu aplikacji",
      interface_language: "Język interfejsu",
      apply_language: "Zastosuj język",
      language_applied: "Język został pomyślnie zastosowany!",
      profile: "Profil",
      message: "Wiadomość",
      send_message: "Wyślij wiadomość",
      favorite: "Ulubione",
      loading: "Ładowanie...",
      error: "Błąd",
      success: "Sukces",
      back: "Wstecz",
      online: "Online",
      offline: "Offline",
      loading_error: "Nie udało się załadować",
      network_error: "Błąd sieci",
      try_again: "Spróbuj ponownie",
    }
  },
  pt: {
    translation: {
      discovery: "Descoberta",
      matching: "Correspondências",
      messages: "Mensagens",
      buzzz: "Buzzz",
      settings: "Configurações",
      settings_subtitle: "Gerencie suas preferências do Alpha_v8",
      appearance: "Aparência",
      appearance_description: "Personalize a aparência do aplicativo",
      language: "Preferências de idioma",
      notifications: "Notificações",
      privacy: "Privacidade",
      discovery_settings: "Descoberta",
      safety: "Segurança",
      signOut: "Sair",
      language_preferences: "Preferências de idioma",
      language_description: "Escolha seu idioma preferido para a interface do aplicativo",
      interface_language: "Idioma da interface",
      apply_language: "Aplicar idioma",
      language_applied: "Idioma aplicado com sucesso!",
      profile: "Perfil",
      message: "Mensagem",
      send_message: "Enviar mensagem",
      favorite: "Favorito",
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      back: "Voltar",
      online: "Online",
      offline: "Offline",
      loading_error: "Falha ao carregar",
      network_error: "Erro de rede",
      try_again: "Tente novamente",
    }
  },
  ru: {
    translation: {
      discovery: "Знакомства",
      matching: "Совпадения",
      messages: "Сообщения",
      buzzz: "Buzzz",
      settings: "Настройки",
      settings_subtitle: "Управляйте настройками Alpha_v8",
      appearance: "Внешний вид",
      appearance_description: "Настройте внешний вид приложения",
      language: "Языковые предпочтения",
      notifications: "Уведомления",
      privacy: "Конфиденциальность",
      discovery_settings: "Знакомства",
      safety: "Безопасность",
      signOut: "Выйти",
      language_preferences: "Языковые предпочтения",
      language_description: "Выберите предпочитаемый язык интерфейса приложения",
      interface_language: "Язык интерфейса",
      apply_language: "Применить язык",
      language_applied: "Язык успешно применен!",
      profile: "Профиль",
      message: "Сообщение",
      send_message: "Отправить сообщение",
      favorite: "Избранное",
      loading: "Загрузка...",
      error: "Ошибка",
      success: "Успех",
      back: "Назад",
      online: "В сети",
      offline: "Не в сети",
      loading_error: "Ошибка загрузки",
      network_error: "Ошибка сети",
      try_again: "Попробовать снова",
    }
  },
  zh: {
    translation: {
      discovery: "发现",
      matching: "匹配",
      messages: "消息",
      buzzz: "Buzzz",
      settings: "设置",
      settings_subtitle: "管理您的Alpha_v8偏好",
      appearance: "外观",
      appearance_description: "自定义应用程序的外观",
      language: "语言偏好",
      notifications: "通知",
      privacy: "隐私",
      discovery_settings: "发现",
      safety: "安全",
      signOut: "退出",
      language_preferences: "语言偏好",
      language_description: "选择您首选的应用程序界面语言",
      interface_language: "界面语言",
      apply_language: "应用语言",
      language_applied: "语言应用成功！",
      profile: "个人资料",
      message: "消息",
      send_message: "发送消息",
      favorite: "收藏",
      loading: "加载中...",
      error: "错误",
      success: "成功",
      back: "返回",
      online: "在线",
      offline: "离线",
      loading_error: "加载失败",
      network_error: "网络错误",
      try_again: "重试",
    }
  },
  ja: {
    translation: {
      discovery: "発見",
      matching: "マッチング",
      messages: "メッセージ",
      buzzz: "Buzzz",
      settings: "設定",
      settings_subtitle: "Alpha_v8の設定を管理",
      appearance: "外観",
      appearance_description: "アプリの外観をカスタマイズ",
      language: "言語設定",
      notifications: "通知",
      privacy: "プライバシー",
      discovery_settings: "発見",
      safety: "安全性",
      signOut: "サインアウト",
      language_preferences: "言語設定",
      language_description: "アプリインターフェースの優先言語を選択",
      interface_language: "インターフェース言語",
      apply_language: "言語を適用",
      language_applied: "言語が正常に適用されました！",
      profile: "プロフィール",
      message: "メッセージ",
      send_message: "メッセージを送信",
      favorite: "お気に入り",
      loading: "読み込み中...",
      error: "エラー",
      success: "成功",
      back: "戻る",
      online: "オンライン",
      offline: "オフライン",
      loading_error: "読み込みに失敗しました",
      network_error: "ネットワークエラー",
      try_again: "再試行",
    }
  },
  ko: {
    translation: {
      discovery: "발견",
      matching: "매칭",
      messages: "메시지",
      buzzz: "Buzzz",
      settings: "설정",
      settings_subtitle: "Alpha_v8 설정 관리",
      appearance: "외관",
      appearance_description: "앱의 외관 커스터마이징",
      language: "언어 설정",
      notifications: "알림",
      privacy: "개인정보",
      discovery_settings: "발견",
      safety: "안전",
      signOut: "로그아웃",
      language_preferences: "언어 설정",
      language_description: "앱 인터페이스의 선호 언어를 선택하세요",
      interface_language: "인터페이스 언어",
      apply_language: "언어 적용",
      language_applied: "언어가 성공적으로 적용되었습니다!",
      profile: "프로필",
      message: "메시지",
      send_message: "메시지 보내기",
      favorite: "즐겨찾기",
      loading: "로딩 중...",
      error: "오류",
      success: "성공",
      back: "뒤로",
      online: "온라인",
      offline: "오프라인",
      loading_error: "로딩에 실패했습니다",
      network_error: "네트워크 오류",
      try_again: "다시 시도",
    }
  },
  ar: {
    translation: {
      discovery: "اكتشاف",
      matching: "مطابقات",
      messages: "الرسائل",
      buzzz: "Buzzz",
      settings: "الإعدادات",
      settings_subtitle: "إدارة تفضيلات Alpha_v8",
      appearance: "المظهر",
      appearance_description: "تخصيص مظهر التطبيق",
      language: "تفضيلات اللغة",
      notifications: "الإشعارات",
      privacy: "الخصوصية",
      discovery_settings: "اكتشاف",
      safety: "الأمان",
      signOut: "تسجيل الخروج",
      language_preferences: "تفضيلات اللغة",
      language_description: "اختر لغتك المفضلة لواجهة التطبيق",
      interface_language: "لغة الواجهة",
      apply_language: "تطبيق اللغة",
      language_applied: "تم تطبيق اللغة بنجاح!",
      profile: "الملف الشخصي",
      message: "رسالة",
      send_message: "إرسال رسالة",
      favorite: "المفضلة",
      loading: "جاري التحميل...",
      error: "خطأ",
      success: "نجح",
      back: "رجوع",
      online: "متصل",
      offline: "غير متصل",
      loading_error: "فشل في التحميل",
      network_error: "خطأ في الشبكة",
      try_again: "حاول مرة أخرى",
    }
  },
  hi: {
    translation: {
      discovery: "खोज",
      matching: "मैचिंग",
      messages: "संदेश",
      buzzz: "Buzzz",
      settings: "सेटिंग्स",
      settings_subtitle: "अपनी Alpha_v8 प्राथमिकताएं प्रबंधित करें",
      appearance: "दिखावट",
      appearance_description: "ऐप की दिखावट को कस्टमाइज़ करें",
      language: "भाषा प्राथमिकताएं",
      notifications: "सूचनाएं",
      privacy: "गोपनीयता",
      discovery_settings: "खोज",
      safety: "सुरक्षा",
      signOut: "साइन आउट",
      language_preferences: "भाषा प्राथमिकताएं",
      language_description: "ऐप इंटरफेस के लिए अपनी पसंदीदा भाषा चुनें",
      interface_language: "इंटरफेस भाषा",
      apply_language: "भाषा लागू करें",
      language_applied: "भाषा सफलतापूर्वक लागू की गई!",
      profile: "प्रोफाइल",
      message: "संदेश",
      send_message: "संदेश भेजें",
      favorite: "पसंदीदा",
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      success: "सफलता",
      back: "वापस",
      online: "ऑनलाइन",
      offline: "ऑफलाइन",
      loading_error: "लोड करने में विफल",
      network_error: "नेटवर्क त्रुटि",
      try_again: "पुनः प्रयास करें",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'preferred-language',
    }
  });

export default i18n;
